export const JWT_COOKIE_NAME = 'jwt_token'
export const LOCALE_COOKIE_NAME = 'locale'
